function loadSlider() {

  setTimeout(function () {

    $('.slider').each(function () {

      var $slider = $(this);

      if ($slider.hasClass('slick-initialized')) return;

      var slideCount = $slider.find('.grid__item').length;
      if (!slideCount) return;

      var thisID = $slider.attr('id');
      var sectionLimit = parseInt($slider.attr('section-limit')) || 4;

      // INIT SLICK
      $slider.slick({
        focusOnSelect: true,
        centerMode: false,
        centerPadding: '0',
        slidesToShow: sectionLimit,
        slidesToScroll: 1,
        arrows: false,
        infinite: false,
        variableWidth: false,
        responsive: [
          { breakpoint: 1280, settings: { slidesToShow: 3 } },
          { breakpoint: 990, settings: { slidesToShow: 2 } },
          { breakpoint: 481, settings: { slidesToShow: 1 } }
        ]
      });

      // UPDATE FUNCTION
      function updateSlider(event, slick, currentSlide) {

        var current = (currentSlide || 0) + 1;
        var slidesToShow = slick.options.slidesToShow || 1;

        var totalSlides = Math.ceil(slideCount / slidesToShow);

        var lastFlag = (current + slidesToShow) >= slideCount;

        // PREV
        if (current === 1) {
          $('.prev[data-slider="' + thisID + '"]').attr('visibility', 'hide');
        } else {
          $('.prev[data-slider="' + thisID + '"]').attr('visibility', 'show');
        }

        // NEXT
        if (lastFlag) {
          $('.next[data-slider="' + thisID + '"]').attr('visibility', 'hide');
        } else {
          $('.next[data-slider="' + thisID + '"]').attr('visibility', 'show');
        }

        // COUNTER
        $slider.closest('.sliderBox, .related-products')
          .find('.slider-counter')
          .text(current + ' / ' + totalSlides);
      }

      // EVENTS (ONLY ONCE)
      $slider.on('init reInit afterChange', updateSlider);

      // INIT NAV STATE
      $slider.slick('setPosition');

      // BUTTONS
      $('.prev[data-slider="' + thisID + '"]').off('click').on('click', function () {
        $slider.slick('slickPrev');
      });

      $('.next[data-slider="' + thisID + '"]').off('click').on('click', function () {
        $slider.slick('slickNext');
      });

    });

  }, 600);
}

$(document).ready(function () {
  loadSlider();
});
